import React, { useEffect } from 'react';
import { CenterFrameLayout } from 'Layouts';
import { StaticLinkButton } from 'Components/Fields/Buttons';
import { useStore } from 'Hooks/useStore';
import './VeteransAdvantageError.css';
import { clearVeteransAdvError } from 'State/Integrations';
import { setLocation } from 'Utils/Path';

const VA_PATH =
  'https://www.wesalute.com/offers/dining-entertainment/fox-news-salutes-you-free-1-year-subscription-fox-nation';

export const VeteransAdvantageError = () => {
  const { routes } = useStore('appConfig');
  const { error: vaError } = useStore('integrations.veteransAdv');

  useEffect(() => {
    return () => {
      clearVeteransAdvError();
    };
  }, []);

  useEffect(() => {
    if (!vaError) {
      setLocation(routes.welcome);
    }
  }, [routes.welcome, vaError]);

  return (
    <CenterFrameLayout modernLayout showLoader={!vaError}>
      <div className="vaErrorMessage">{vaError}</div>
      <StaticLinkButton className="backToVaButton" path={VA_PATH} text="Back to WeSalute" />
    </CenterFrameLayout>
  );
};
